module.exports = __webpack_public_path__ + "static/media/01_A5_02.3bbea79a.png";